module.exports = __webpack_public_path__ + "static/media/bunbury_central.90542cd6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/bunbury_central.jpg
// module id = 494
// module chunks = 0